import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "创建成功",
  "use": "创建成功-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"创建成功\"><path d=\"M440.3712 635.392l304.128-304.128L802.4064 389.12l-361.984 362.0352-21.76-21.7088-181.0432-181.0432 57.9584-57.856L440.32 635.392zM512 0c282.7776 0 512 229.2224 512 512s-229.2224 512-512 512S0 794.7776 0 512 229.2224 0 512 0z m0 81.92a430.08 430.08 0 1 0 0 860.16 430.08 430.08 0 0 0 0-860.16z\" p-id=\"2350\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol